import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div>
      <section style={{ background: 'var(--ije-black)', color: '#fff' }}>
        <div className="container-x py-24 max-w-4xl">
          <span className="eyebrow" style={{ color: 'var(--ije-pink-light)' }}>About IJE HAUS</span>
          <h1 className="h-display text-4xl md:text-6xl mt-4">A boutique wholesale house for intimate goods.</h1>
        </div>
      </section>
      <section className="container-x py-20 max-w-3xl">
        <p className="sans text-lg text-neutral-700 leading-relaxed">
          IJE HAUS LLC operates a curated wholesale storefront for approved retail partners in the adult
          products trade. We select brands from across the industry — from established houses to boutique
          labels — and add new lines on a rolling basis. The experience is distilled: essentials, no clutter.
        </p>
        <div className="mt-14 grid md:grid-cols-2 gap-10">
          <div>
            <h3 className="serif text-2xl">What we sell</h3>
            <p className="sans text-sm text-neutral-500 mt-3 leading-relaxed">
              Curated brands across dildos, butt plugs, male enhancement, lubricants, and adjacent
              categories. Our roster grows continuously — trade partners can request specific labels
              after signing in.
            </p>
          </div>
          <div>
            <h3 className="serif text-2xl">How we ship</h3>
            <p className="sans text-sm text-neutral-500 mt-3 leading-relaxed">
              We hold no physical inventory. Every order is drop-shipped by the supplier direct to your
              store or your customer. Confirmed quotes lock the price; the supplier fulfills.
            </p>
          </div>
        </div>
        <div className="mt-14 border-t border-neutral-200 pt-10 flex items-center justify-between gap-6 flex-wrap">
          <p className="serif text-2xl italic">Ready to open an account?</p>
          <Link to="/apply" className="btn-primary">Apply for Wholesale</Link>
        </div>
      </section>
    </div>
  );
}
